// core/auth/auth.guard.ts
import { CanActivateFn } from '@angular/router';
import { inject } from '@angular/core';
import { AuthService } from '@core/auth/auth.service';

// When unauthenticated, start Keycloak login instead of returning a bare false.
export const canActivateAuth: CanActivateFn = () => {
  const auth = inject(AuthService);
  if (auth.isAuthenticated()) {
    return true;
  }

  void auth.login();
  return false;
};
